export default "__VITE_ASSET__bf2fb741__"